export enum ModalPlacement {
  Top = 'top',
  Bottom = 'bottom',
}
